import { render, staticRenderFns } from "./task-tabs.vue?vue&type=template&id=03bde314&"
import script from "./task-tabs.vue?vue&type=script&lang=js&"
export * from "./task-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports